import React from 'react'

import { FormattedMessage } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'

import Price from '@components/UI/Price/Price'
import { IApplicationState } from '@store'
import { selectCPE, selectCPECurrency } from '@store/submissions'
import Theme from '@theme'
import { H5 } from '@tribegroup'

interface IProps {
  submissionId: number
}

export const SubHeaderLabelCPE: React.FC<IProps> = ({ submissionId }) => {
  const { cpe, currency } = useSelector(
    (state: IApplicationState) => ({
      cpe: selectCPE(state, submissionId),
      currency: selectCPECurrency(state, submissionId),
    }),
    shallowEqual,
  )

  return (
    <H5 color={Theme.grey700Color} uppercase inline light>
      {Boolean(cpe) && (
        <React.Fragment>
          <FormattedMessage id="submission.performance.cpe" />
          &nbsp;
          <Price quantity={cpe} currency={currency} />
        </React.Fragment>
      )}
    </H5>
  )
}

export default SubHeaderLabelCPE
